/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SDCCAPayments' store object.
 * @namespace SDCCAPaymentsSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASDCCAPayments';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCCAPaymentsSelectors
   */
  static fetchSdccaPayments = state => state[selectors.moduleIdentifier].fetchSdccaPayments.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCCAPaymentsSelectors
   */
  static isFetchingFetchSdccaPayments = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdccaPayments.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCCAPaymentsSelectors
   */
  static fetchSdccaPaymentsError = state =>
    state[selectors.moduleIdentifier].fetchSdccaPaymentsError.payload;
}
